import { render, staticRenderFns } from "./GeneralProvidersTable.vue?vue&type=template&id=28f0cdf6&scoped=true"
import script from "./GeneralProvidersTable.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralProvidersTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GeneralProvidersTable.vue?vue&type=style&index=0&id=28f0cdf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f0cdf6",
  null
  
)

export default component.exports